import type { SVGProps } from 'react';
const DawnFlagWW = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-WW_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-WW_svg__a)">
      <path fill="#19BFBF" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M11 13.867c3.182 0 5.762-2.627 5.762-5.867S14.182 2.133 11 2.133 5.238 4.76 5.238 8s2.58 5.867 5.762 5.867m4.686-5.334a4.79 4.79 0 0 1-2.944 3.929c.511-1.06.81-2.44.867-3.929zM11 12.8q.153 0 .303-.01c.72-.867 1.18-2.457 1.257-4.257H9.44c.077 1.8.538 3.39 1.257 4.257q.15.01.303.01m-1.742-.338a4.79 4.79 0 0 1-2.943-3.929H8.39c.058 1.49.356 2.87.867 3.929m.182-4.995h3.12c-.076-1.8-.537-3.39-1.257-4.257a5 5 0 0 0-.606 0c-.72.867-1.18 2.457-1.257 4.257m-.182-3.929c-.51 1.06-.81 2.44-.867 3.929H6.315a4.79 4.79 0 0 1 2.943-3.929m6.428 3.929h-2.077c-.057-1.49-.356-2.87-.867-3.929a4.79 4.79 0 0 1 2.944 3.929"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagWW;
